// getLivestreamComputedMode.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLivestreamMode from '../selector/getLivestreamMode.js';

import {
  LivestreamMode,
  CROWDFUNDING_MODES,
  ExclusivePrivateStatus,
} from '../resource/liveStreamConstants.js';

/**
 * Select the mode a livestream is in, as one value.
 *
 * Every mode the session can name is passed through as reported — the
 * crowdfunding stages and the legacy group private stream alike. Only 1v1 is
 * decided here, off `exclusivePrivate.status`: the session reports `exclusive`
 * too, but only the pusher events carry its sub-stages, so that is the source
 * of truth and the reported value is ignored. The preset status never decides a
 * mode.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {string} The selected LivestreamMode.
 */
const getLivestreamComputedMode = createCachedSelector(
  (state, streamId) =>
    getLiveStreamData(state, [streamId, 'exclusivePrivate'], 'status'),
  (state, streamId) => getLivestreamMode(state, streamId),
  (exclusivePrivateStatus, mode) => {
    if ([...CROWDFUNDING_MODES, LivestreamMode.PRIVATE].includes(mode)) {
      return mode;
    } else if (
      [
        ExclusivePrivateStatus.PREPARING,
        ExclusivePrivateStatus.PERFORMING,
      ].includes(exclusivePrivateStatus)
    ) {
      return LivestreamMode.EXCLUSIVE;
    }

    return LivestreamMode.FREE;
  }
)((state, streamId) => `${streamId}`);

export default getLivestreamComputedMode;
